import React, { Component } from 'react';
import Fab from '@material-ui/core/Fab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Zoom from '@material-ui/core/Zoom';

class ScrollContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollBottom: true,
      scrollTop: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    return () => { return window.removeEventListener('scroll', this.handleScroll); };
  }

    handleScroll=() => {
      if (window.innerHeight + document.documentElement.scrollTop !== document.documentElement.offsetHeight) this.setState({ scrollBottom: true });
      else this.setState({ scrollBottom: false });
      if (document.documentElement.scrollTop === 0) this.setState({ scrollTop: false });
      else this.setState({ scrollTop: true });
    }

    handleClick=(to) => {
      if (to === 'top') {
        window.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth',
        });
      } else if (to === 'bottom') {
        window.scrollTo({
          left: 0,
          top: document.documentElement.offsetHeight,
          behavior: 'smooth',
        });
      }
    }

    render() {
      return (
        <>
          {this.props.children}
          <Zoom in={this.state.scrollTop}>
            <div
              onClick={() => { return this.handleClick('top'); }}
              role="presentation"
              style={{
                margin: 0, top: 'auto', right: 40, bottom: 65, left: 'auto', position: 'fixed',
              }}
            >
              <Fab color="secondary" size="small" aria-label="scroll back to top">
                <KeyboardArrowUpIcon />
              </Fab>
            </div>
          </Zoom>

          <Zoom in={this.state.scrollBottom}>
            <div
              onClick={() => { return this.handleClick('bottom'); }}
              role="presentation"
              style={{
                margin: 0, top: 'auto', right: 40, bottom: 20, left: 'auto', position: 'fixed',
              }}
            >
              <Fab color="secondary" size="small" aria-label="scroll back to top">
                <KeyboardArrowDownIcon />
              </Fab>
            </div>
          </Zoom>
        </>
      );
    }
}

export default ScrollContainer;
